import { ace } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';
import { MarketCountryCode } from '@axo/shared/data-access/types/ace_index';

export const findBucketApplications =
  ({ token, url: { service: baseURL } }: IAPI) =>
  (req: ace.FindApplicationBucketReq): Promise<ace.FindApplicationBucketRes> =>
    send({
      baseURL,
      token,
      path: '/ace/bucket/v1/applications',
      method: 'GET',
      searchParams: req,
    });

export const getApplicationBucket =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({ id }: { id: string }): Promise<ace.GetApplicationBucketRes> =>
    send({
      baseURL,
      token,
      path: `/ace/bucket/v1/applications/${encodeURIComponent(id)}`,
      method: 'GET',
    });

export const processApplicationBucket =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({ id }: { id: string }): Promise<ace.ProcessApplicationBucketRes> =>
    send({
      baseURL,
      token,
      path: `/ace/bucket/v1/applications/${encodeURIComponent(id)}/process`,
      method: 'PATCH',
    });

export const listApplicationBucketRevisions =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({ id }: { id: string }): Promise<ace.ListApplicationBucketRevisionsRes> =>
    send({
      baseURL,
      token,
      path: `/ace/bucket/v1/applications/${encodeURIComponent(id)}/revisions`,
      method: 'GET',
    });

export const getBucketSummaries =
  ({ token, url: { service: baseURL } }: IAPI) =>
  (): Promise<ace.GetApplicationBucketSummariesRes> =>
    send({
      baseURL,
      token,
      path: `/ace/bucket/v1/summary`,
      method: 'GET',
    });

export const listBuckets =
  ({ token, url: { service: baseURL } }: IAPI) =>
  (req: ace.ListBucketsReq): Promise<ace.ListBucketsRes> =>
    send({
      baseURL,
      token,
      path: `/ace/bucket/v1/buckets`,
      method: 'GET',
      searchParams: { ...req, limit: 1000, offset: 0 }, // Hard coding offsets "for now" 🍻.
    });

export const getBucket =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({ id }: { id: string }): Promise<ace.GetBucketRes> =>
    send({
      baseURL,
      token,
      path: `/ace/bucket/v1/buckets/${encodeURIComponent(id)}`,
      method: 'GET',
    });

export const patchAssignee =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    clientID,
    marketCountry,
  }: {
    clientID: string;
    marketCountry: MarketCountryCode | '';
  }): Promise<ace.Assignee> =>
    send({
      baseURL,
      token,
      path: `/ace/bucket/v1/assignee/${encodeURIComponent(clientID)}`,
      method: 'PATCH',
      body: {
        ClientID: clientID,
        AvailableInCountry: marketCountry,
      },
    });

export const getAssignee =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({ clientID }: { clientID: string }): Promise<ace.Assignee> =>
    send({
      baseURL,
      token,
      path: `/ace/bucket/v1/assignee/${encodeURIComponent(clientID)}`,
      method: 'GET',
    });

export const patchProcessApplication =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    applicationID,
  }: {
    applicationID: string;
  }): Promise<ace.ApplicationBucket> =>
    send({
      baseURL,
      token,
      path: `/ace/bucket/v1/applications/${encodeURIComponent(applicationID)}/process`,
      method: 'PATCH',
    });
